var render = function render(){var _vm=this,_c=_vm._self._c;return _c('h4',{staticClass:"font-weight-bold mt-0 mb-6 blue-grey--text text--darken-3",attrs:{"data-testid":"widget-title"},domProps:{"innerHTML":_vm._s(_vm.sanitizedTitle)}})
}
var staticRenderFns = []

export { render, staticRenderFns }